import * as React from 'react';
import { flushSync } from 'react-dom';
import { Virtualizer, elementScroll, observeElementOffset, observeElementRect, observeWindowOffset, observeWindowRect, windowScroll, } from './core';
export * from '@tanstack/virtual-core';
const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options) {
    const rerender = React.useReducer(() => ({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance, sync) => {
            if (sync) {
                flushSync(rerender);
            }
            else {
                rerender();
            }
            options.onChange?.(instance, sync);
        },
    };
    const [instance] = React.useState(() => new Virtualizer(resolvedOptions));
    instance.setOptions(resolvedOptions);
    useIsomorphicLayoutEffect(() => {
        return instance._didMount();
    }, []);
    useIsomorphicLayoutEffect(() => {
        return instance._willUpdate();
    });
    return instance;
}
export function useVirtualizer(options) {
    return useVirtualizerBase({
        observeElementRect: observeElementRect,
        observeElementOffset: observeElementOffset,
        scrollToFn: elementScroll,
        ...options,
    });
}
export function useWindowVirtualizer(options) {
    return useVirtualizerBase({
        getScrollElement: () => (typeof document !== 'undefined' ? window : null),
        observeElementRect: observeWindowRect,
        observeElementOffset: observeWindowOffset,
        scrollToFn: windowScroll,
        initialOffset: () => (typeof document !== 'undefined' ? window.scrollY : 0),
        ...options,
    });
}
